<template>
  <atendantForm :typeEndPoint="'academicAttendantEdit'" :dataParams="this.$route.params" />
</template>
<script>
import atendantForm from '@/components/modules/academic/attendant/form'
export default {
  name: 'academicAttendantEdit',
  components: {
    atendantForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/academic/attendant/edit.vue